import React from "react";
import { MapPin, Clock, Facebook } from "lucide-react";
import { company } from "../mock";

export default function TopBar() {
  return (
    <div className="bg-neutral-950 text-neutral-300 text-xs md:text-sm border-b border-neutral-800">
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex flex-wrap items-center justify-between gap-2 py-2">
        <div className="flex flex-wrap items-center gap-x-6 gap-y-1">
          <span className="inline-flex items-center gap-2">
            <MapPin className="w-3.5 h-3.5 text-amber-400" />
            <span className="text-neutral-400">Adresa:</span>
            <span>Rosulje 77, 74264 Jelah, BiH</span>
          </span>
          <span className="inline-flex items-center gap-2">
            <Clock className="w-3.5 h-3.5 text-amber-400" />
            <span className="text-neutral-400">Radno vrijeme:</span>
            <span>Pon – Pet, 08:00 – 16:00h</span>
          </span>
        </div>
        <a
          href={company.facebook}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 text-neutral-300 hover:text-amber-400 transition-colors"
        >
          <Facebook className="w-4 h-4" />
          <span>Facebook</span>
        </a>
      </div>
    </div>
  );
}
